import React, { useEffect, useRef, useState } from "react";
import { STATS } from "../lib/siteData";

function CountUp({ value }) {
  const [display, setDisplay] = useState(value);
  const ref = useRef(null);
  const numericMatch = value.match(/[\d,]+/);
  const numeric = numericMatch ? parseInt(numericMatch[0].replace(/,/g, ""), 10) : null;
  const suffix = numericMatch ? value.replace(numericMatch[0], "") : "";

  useEffect(() => {
    if (numeric === null) return;
    const el = ref.current;
    if (!el) return;
    const obs = new IntersectionObserver(([entry]) => {
      if (!entry.isIntersecting) return;
      const start = performance.now();
      const dur = 1600;
      const tick = (now) => {
        const t = Math.min(1, (now - start) / dur);
        const eased = 1 - Math.pow(1 - t, 3);
        const current = Math.floor(numeric * eased);
        setDisplay(`${current.toLocaleString()}${suffix}`);
        if (t < 1) requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
      obs.disconnect();
    });
    obs.observe(el);
    return () => obs.disconnect();
  }, [numeric, suffix]);

  return (
    <span ref={ref} style={{ fontFamily: '"Cormorant Garamond", serif' }}>
      {numeric === null ? value : display}
    </span>
  );
}

export default function Achievements() {
  return (
    <section
      id="achievements"
      data-testid="achievements-section"
      className="bg-ink text-ivory py-20 sm:py-28 relative"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "url(\"data:image/svg+xml;utf8,<svg xmlns='http://www.w3.org/2000/svg' width='200' height='200'><filter id='n'><feTurbulence type='fractalNoise' baseFrequency='0.85' numOctaves='2'/></filter><rect width='100%25' height='100%25' filter='url(%23n)'/></svg>\")",
        }}
      />
      <div className="container-prose relative">
        <div className="max-w-3xl">
          <p className="overline text-saffron">07 — Impact</p>
          <h2 className="h2-display mt-4 text-4xl sm:text-5xl">
            Numbers that took <span className="italic text-saffron">two decades</span> to earn.
          </h2>
        </div>

        <div className="mt-14 grid grid-cols-2 md:grid-cols-4 gap-y-12 gap-x-8">
          {STATS.map((s, i) => (
            <div key={i} data-testid={`stat-${i}`} className="border-l border-ivory/15 pl-5">
              <p className="text-5xl sm:text-7xl font-light leading-none text-ivory">
                <CountUp value={s.value} />
              </p>
              <p className="mt-4 text-[11px] uppercase tracking-[0.22em] text-ivory/60">
                {s.label}
              </p>
            </div>
          ))}
        </div>

        <div className="mt-14 max-w-2xl body-prose text-ivory/75 text-base sm:text-lg border-t border-ivory/15 pt-8">
          17+ national workshops for CBSE in 2024 alone. A decade-long partnership with the
          US Embassy's RELO programme. International faculty status with TESOL.
          Selected international virtual presenter at ASCD &amp; ISTE Live 2026.
          A ripple of practice that has reached over a million students — directly and through
          the trainers and teachers Karamjeet has shaped.
        </div>
      </div>
    </section>
  );
}
